import React from 'react';
import {Footer, Header} from '../templates';
import PropTypes from 'prop-types';
import StaticPage from 'pages/authentication/staticPage/StaticPage';

const Layout: React.FC = ({ children }) => {
  return (
    <div className="content">
      <Header/>
      <StaticPage/>
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export { Layout };
